import z from "zod";

const googleCalendarErrorTypeValues = ["PLACEHOLDER"] as const;

const googleCalendarErrorTypeSchema = z.enum(googleCalendarErrorTypeValues);
const GoogleCalendarErrorType = googleCalendarErrorTypeSchema.enum;
type GoogleCalendarErrorType = z.infer<typeof googleCalendarErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GoogleCalendarErrors = {
  errorType: typeof GoogleCalendarErrorType.PLACEHOLDER;
  data: undefined;
};

export const googleCalendarErrorDetails: Record<GoogleCalendarErrorType, ErrorDetails> = {
  [GoogleCalendarErrorType.PLACEHOLDER]: {
    sentryDescription: "This is just a placeholder error type",
  },
};
